import { operation, trip } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  // getTripRoute(payload = {}) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get(`${operation.tripRouteOperation}${payload.id}/trip_routes/`, {
  //         params: payload.params,
  //       })
  //       .then((res) => {
  //         resolve(handleResponse(res));
  //       })
  //       .catch((err) => {
  //         reject(handleError(err));
  //       });
  //   });
  // },
  getTripRoute(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}${id}/trip_routes/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOperationOrderList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${operation.operationBase}trip_orders/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverLocationList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${operation.operationBase}driver_location/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOperationTripList(params = {}) {
    let url =
      params && params.completed_trips ? "completed_trips" : "ongoing_trips";
    return new Promise((resolve, reject) => {
      axios
        .get(`${operation.operationBase}${url}/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOperationOrderStatisticsList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${operation.operationBase}order_statistics/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripCount(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${operation.operationBase}trip_statistics/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverOperationList(params = {}) {
    if (
      params &&
      params.search &&
      (params.search == null || params.search.trim().length == 0)
    ) {
      delete params.search;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`${operation.driverOperation}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  // get operation trip details based on trip_id
  getOperationTrip(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(params.trip, {
          // params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOperationOverview(params) {
    let url = operation.overviewOperation;
    if (params && params.trip) {
      url = params.trip;
      delete params.trip;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addOperation(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${operation.operationBase}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateOperation(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${operation.operationBase}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  uploadOperationDocuments(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${operation.operationBase}${payload.id}/upload/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deleteOperationDocument(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${operation.operationDocumentDelete}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  downloadOperationData(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${operation.operationDownload}`, {
          responseType: "blob",

          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
